"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Duration = void 0;
var Duration = /** @class */ (function () {
    function Duration() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.value = null;
        this.unit = 's';
        switch (args.length) {
            case 1:
                if (typeof args[0] === "string") {
                    this.duration = args[0];
                }
                else {
                    this.timestamp = args[0];
                }
                break;
            case 2:
                this.value = args[0];
                this.unit = args[1];
                break;
        }
    }
    Duration.prototype.getValueByUnit = function (unit) {
        switch (unit) {
            case "s":
                return this.seconds;
            case "m":
                return this.minutes;
            case "h":
                return this.hours;
            case "d":
                return this.days;
        }
    };
    Duration.prototype.isEmpty = function () {
        return this.value === null;
    };
    Object.defineProperty(Duration.prototype, "timestamp", {
        get: function () {
            if (this.milliseconds === null) {
                return null;
            }
            else {
                // 毫秒级时间戳是整数
                return Math.round(this.milliseconds);
            }
        },
        set: function (timestamp) {
            this.milliseconds = timestamp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Duration.prototype, "milliseconds", {
        get: function () {
            if (this.seconds === null) {
                return null;
            }
            else {
                return this.seconds * 1000;
            }
        },
        set: function (milliseconds) {
            if (milliseconds === null) {
                this.value = null;
            }
            else {
                this.seconds = milliseconds / 1000;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Duration.prototype, "seconds", {
        // 秒数
        get: function () {
            if (this.value === null) {
                return null;
            }
            switch (this.unit) {
                case "s":
                    return this.value;
                case "m":
                    return this.value * 60;
                case "h":
                    return this.value * 3600;
                case "d":
                    return this.value * 3600 * 24;
                default:
                    return 0;
            }
        },
        set: function (seconds) {
            if (seconds === null) {
                this.value = null;
            }
            // value最好为整数
            else if (seconds % (3600 * 24) === 0) {
                this.value = seconds / (3600 * 24);
                this.unit = 'd';
            }
            else if (seconds % 3600 === 0) {
                this.value = seconds / 3600;
                this.unit = 'h';
            }
            else if (seconds % 60 === 0) {
                this.value = seconds / 60;
                this.unit = 'm';
            }
            else {
                this.value = seconds;
                this.unit = 's';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Duration.prototype, "minutes", {
        // 分钟数
        get: function () {
            if (this.seconds === null) {
                return null;
            }
            else {
                return this.seconds / 60;
            }
        },
        set: function (minutes) {
            if (minutes === null) {
                this.value = null;
            }
            else {
                this.seconds = minutes * 60;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Duration.prototype, "hours", {
        // 小时数
        get: function () {
            if (this.seconds === null) {
                return null;
            }
            else {
                return this.seconds / 3600;
            }
        },
        set: function (hours) {
            if (hours === null) {
                this.value = null;
            }
            else {
                this.seconds = hours * 3600;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Duration.prototype, "days", {
        // 天数
        get: function () {
            if (this.seconds === null) {
                return null;
            }
            else {
                return this.seconds / (3600 * 24);
            }
        },
        set: function (days) {
            if (days === null) {
                this.value = null;
            }
            else {
                this.seconds = days * 3600 * 24;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Duration.prototype, "duration", {
        get: function () {
            if (this.value === null) {
                return "";
            }
            else {
                return this.value + this.unit;
            }
        },
        set: function (duration) {
            if (duration && duration.length >= 2) {
                var value = parseFloat(duration.slice(0, duration.length - 1));
                if (!isNaN(value) && value >= 0) {
                    this.value = value;
                }
                else {
                    this.value = null;
                }
                switch (duration[duration.length - 1]) {
                    case 's':
                        this.unit = 's';
                        break;
                    case 'm':
                        this.unit = 'm';
                        break;
                    case 'h':
                        this.unit = 'h';
                        break;
                    case 'd':
                        this.unit = 'd';
                        break;
                    default:
                        this.value = null;
                        this.unit = 's';
                }
            }
            else {
                this.value = null;
                this.unit = 's';
            }
        },
        enumerable: false,
        configurable: true
    });
    Duration.getLabel = function (unit) {
        switch (unit) {
            case "d":
                return '天';
            case "h":
                return '小时';
            case "m":
                return '分钟';
            case "s":
                return '秒';
        }
    };
    Duration.getUnit = function (label) {
        switch (label) {
            case '秒':
                return 's';
            case '分钟':
                return 'm';
            case '小时':
                return 'h';
            case '天':
                return 'd';
            default:
                return 's';
        }
    };
    Object.defineProperty(Duration.prototype, "unit_label", {
        get: function () {
            return Duration.getLabel(this.unit);
        },
        set: function (label) {
            this.unit = Duration.getUnit(label);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Duration.prototype, "value_text", {
        get: function () {
            if (this.value === null) {
                return "";
            }
            else {
                return this.value + "";
            }
        },
        set: function (val) {
            var value = parseFloat(val);
            if (isNaN(value)) {
                this.value = null;
            }
            else {
                this.value = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Duration.Pattern = new RegExp("^(\\d+(\\.\\d+)?)([smhd])$");
    Duration.Units = {
        s: { label: '秒', value: 's' },
        m: { label: '分钟', value: 'm' },
        h: { label: '小时', value: 'h' },
        d: { label: '天', value: 'd' }
    };
    return Duration;
}());
exports.Duration = Duration;
//# sourceMappingURL=duration.js.map